const formatDuration = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);

    // Calculate hours, minutes, seconds
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    // Pad with zeros
    const pad = (num) => String(num).padStart(2, '0');

    // Return format based on duration
    if (hours > 0) {
        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    }
    return `${pad(minutes)}:${pad(seconds)}`;
}

export default formatDuration;